import { createContext } from "react";

import { Media } from "@/features/push/domain/models/media";

export interface MymCloudContextType {
  mymCloudSelectedMedias: Media[];
  setMymCloudSelectedMedias: React.Dispatch<React.SetStateAction<Media[]>>;
}

export const MymCloudContext = createContext<MymCloudContextType>({
  mymCloudSelectedMedias: [],
  setMymCloudSelectedMedias: () => ({})
});
